import * as yup from 'yup';

let createTicketValidationForm = yup.object().shape({
  queue: yup.string().required('Subject is required'),
  priority: yup.string().required('Priority is required'),
  description: yup.string().required('Description is required'),
});
const orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required('Remark is required'),
});

export { createTicketValidationForm, orderRemarksValidationForm };
